export default "__VITE_ASSET__DdXOPnfJ__"